import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  onAuthStateChanged,
  signOut,
  deleteUser as firebaseDeleteUserSDK
} from "firebase/auth";

import { getAnalytics } from "firebase/analytics";

import api from "./api";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APP_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_APP_MEASUREMENT_ID
};

/* Init */
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export const firebaseLoginGoogle = () => signInWithPopup(auth, googleProvider);
export const firebaseLogout = () => signOut(auth);
export const firebaseDeleteUser = () => firebaseDeleteUserSDK(auth.currentUser);
export const firebaseGetToken = async () => {
  if (!auth.currentUser) return null;
  return await auth.currentUser.getIdToken();
};
export const firebaseGetUser = () => auth.currentUser;
export const firebaseAuthListener = (cb) => onAuthStateChanged(auth, cb);

// /* ===== Auth State System ===== */

// let authListener = null;

// export const initAuthListener = (callback) =>
// {
//   if (authListener) return;

//   authListener = onAuthStateChanged(auth, async (user) =>
//   {
//     if (user)
//     {
//       const token = await user.getIdToken();
//       const tokenResult = await user.getIdTokenResult();

//       const userData = {
//         loggedIn: true,

//         // Basic identity
//         uid: user.uid,
//         name: user.displayName,
//         email: user.email,
//         emailVerified: user.emailVerified,
//         phoneNumber: user.phoneNumber,
//         isAnonymous: user.isAnonymous,
//         photo: user.photoURL,
//         tenantId: user.tenantId,
//         providerId: user.providerId,

//         // Provider data (Google identity)
//         providerData: user.providerData,

//         // Token
//         token,

//         // Token metadata
//         tokenInfo:
//         {
//           issuedAtTime: tokenResult.issuedAtTime,
//           expirationTime: tokenResult.expirationTime,
//           authTime: tokenResult.authTime,
//           signInProvider: tokenResult.signInProvider,
//           claims: tokenResult.claims
//         },

//         // Account metadata
//         metadata:
//         {
//           creationTime: user.metadata.creationTime,
//           lastSignInTime: user.metadata.lastSignInTime
//         }
//       };

//       callback(userData);
//     }
//     else
//     {
//       callback({
//         loggedIn: false,
//         user: null
//       });
//     }
//   });
// };

// /* ===== Login ===== */

// export const loginWithGoogle = async () => {
//   const result = await signInWithPopup(auth, googleProvider);
//   return result.user;
// };

// /* ===== Logout ===== */

// export const logout = async () => {
//   sessionUser = null;
//   backendUser = null;
//   await signOut(auth);
// };

// /* ===== Delete User ===== */

// export const deleteAccount = async () =>
// {
//   const user = auth.currentUser;

//   if (!user) {
//     throw new Error("No user logged in");
//   }

//   await firebaseDeleteUser(user);

//   sessionUser = null;
//   backendUser = null;

//   await signOut(auth);
// };


// /* ===== Utils ===== */

// export const getCurrentUser = () => auth.currentUser;

// export const getToken = async () =>
// {
//   const user = auth.currentUser;
//   if (!user) return null;
//   return await user.getIdToken();
// };


// /* ================= INTERNAL CACHE ================= */

// let sessionUser = null;     // firebase identity
// let backendUser = null;     // mysql profile
// let listenerStarted = false;

// /* ================= LISTENER ================= */

// export const initAuthSystem = (callback) => {
//   if (listenerStarted) return;
//   listenerStarted = true;

//   onAuthStateChanged(auth, async (user) => {
//     if (!user) {
//       sessionUser = null;
//       backendUser = null;
//       callback(null);
//       return;
//     }

//     // Firebase session exists
//     sessionUser = user;

//     const token = await user.getIdToken();

//     // If backend already loaded → use cache
//     if (backendUser) {
//       callback({ sessionUser, backendUser, token });
//       return;
//     }

//     // Load backend profile ONCE
//     const res = await api.loadUser(token);
//     backendUser = res.data;

//     callback({ sessionUser, backendUser, token });
//   });
// };

// /* ================= GETTERS ================= */

// export const getSessionUser = () => sessionUser;
// export const getBackendUser = () => backendUser;